import animateNavigation from './MobileNavAnimations';
import mobileNavScroll from './MobileNavHomepage';

var MobileNav = function(){
  var body;
  var toggleButton;
  var mobileNav;
  var isOpen;
  var dropdownItems;
  var masthead;
  
  var _init = function(){
    body = document.body;
    toggleButton = document.getElementById('mobileNavToggle');
    mobileNav = document.getElementById('mobileNav');
    isOpen = false;
    dropdownItems = mobileNav.getElementsByClassName('m-mobile-nav__link');
    masthead = document.querySelector('.m-eday-masthead');

    if (masthead.classList.contains('m-eday-masthead--transparent')) {
      mobileNavScroll.init();
    }

    _addEventListeners();
  };

  var _addEventListeners = function(){
    toggleButton.addEventListener('click', _toggleNavigation);

    [].map.call(dropdownItems, function(button){
      button.addEventListener('click', _toggleSubItems);
    });
  };

  var _toggleNavigation = function(){
    body.classList.toggle('is-mobile-menu-active');

    if (isOpen) {
      isOpen = false;
      animateNavigation.reset();
      _closeSubItems();
    }else if(!isOpen){
      isOpen = true;
    }

    if (isOpen) {
      animateNavigation.init();
    }
  };

  var _toggleSubItems = function(e){
    if (!e.currentTarget.parentNode.classList.contains('open')) {
      e.currentTarget.parentNode.classList.add('open');
    }else{
      e.currentTarget.parentNode.classList.remove('open');
    }
  }

  var _closeSubItems = function(){
    [].map.call(mobileNav.getElementsByClassName('open'), function(button){
      button.classList.remove('open');
    });

  }

  return {
    init: _init,
  }
}();

MobileNav.init();


// WEBPACK FOOTER //
// ./resources/assets/js/partials/MobileNav.js